import Request from '@/plugins/request';

export function getDownloads(params) {
  return Request.get('downloads', { params })
}

export function createDownload() {
  return Request.get(`downloads/create`)
}

export function storeDownload(data) {
  return Request.post('downloads', data)
}

export function updateDownload(id, data) {
  return Request.put(`downloads/${id}`, data)
}

export function editDownload(id) {
  return Request.get(`downloads/${id}/edit`)
}

export function destroyDownload(id) {
  return Request.delete(`downloads/${id}`)
}
